import { render, staticRenderFns } from "./TrafficTaskPage.vue?vue&type=template&id=eeb858a8&scoped=true&"
import script from "./TrafficTaskPage.vue?vue&type=script&lang=js&"
export * from "./TrafficTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb858a8",
  null
  
)

export default component.exports